module.exports = __webpack_public_path__ + "static/media/Infinity-loader.0cfb2e48.svg";